export const environment = {
  production: true,
  apiUrl: 'https://us-central1-trazabilidad-fipa.cloudfunctions.net',
  firebase: {
    apiKey: "AIzaSyC1RfYF3VgXUzdGiBKvPaPx2wFyawf4X2Y",
    authDomain: "trazabilidad-fipa.web.app",
    projectId: "trazabilidad-fipa",
    storageBucket: "trazabilidad-fipa.firebasestorage.app",
    messagingSenderId: "885576417133",
    appId: "1:885576417133:web:d2f5054b59d7204250a464"
  },
  
  /*firebase: {
    apiKey: "AIzaSyC2CYmnTGyv_OCvV3dcOoaBCXRFqFRNlUc",
    authDomain: "trazabilidad-fipa-dev.firebaseapp.com",
    projectId: "trazabilidad-fipa-dev",
    storageBucket: "trazabilidad-fipa-dev.firebasestorage.app",
    messagingSenderId: "409766997225",
    appId: "1:409766997225:web:18c2a6ce5c857c591c1478"
  },*/
  google_maps_key: 'AIzaSyAtXUlnVYdbxgDXeOm5khvVlcxN-N3-2Zs',
};